module.exports = __webpack_public_path__ + "img/icon-expire.aed225c5.svg";